import { render, staticRenderFns } from "./WorkspaceInspector.vue?vue&type=template&id=695a5375&scoped=true"
import script from "./WorkspaceInspector.vue?vue&type=script&lang=js"
export * from "./WorkspaceInspector.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceInspector.vue?vue&type=style&index=0&id=695a5375&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a5375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695a5375')) {
      api.createRecord('695a5375', component.options)
    } else {
      api.reload('695a5375', component.options)
    }
    module.hot.accept("./WorkspaceInspector.vue?vue&type=template&id=695a5375&scoped=true", function () {
      api.rerender('695a5375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceInspector.vue"
export default component.exports